import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { getProfileOwner, isCurrentUserProfileOwner } from '../../../../../selectors/users';
import EmptyState from '../../../../EmptyState';

import s from './OriginalsEmptyState.scss';

export interface Props {
  view: 'wide' | 'large' | 'small';
}

export const OriginalsEmptyState: FC<Props> = ({ view = 'large' }) => {
  const { t } = useTranslation();
  const { user } = useSelector(getProfileOwner);
  const isOwner = useSelector(isCurrentUserProfileOwner);

  if (isOwner) {
    return (
      <EmptyState
        className={classnames(s['root'], s[view])}
        title={t('pages.shop.emptyState.originals.title')}
        subtitle={t('pages.shop.emptyState.originals.subtitle')}
        withButton
        buttonLabel={t('pages.shop.emptyState.originals.submitButton')}
        buttonHref={Url.studio({ openCreateForm: true })}
        view={'small'}
        biData={BiData<DefaultBiEvent>({
          evid: 2,
          click_info: 'create_original',
          sectionname: 'originals',
        })}
      />
    );
  }

  return (
    <EmptyState
      className={classnames(s['root'], s[view])}
      title={t('pages.shop.emptyState.originals.title.visitor')}
      subtitle={t('pages.shop.emptyState.originals.subtitle.visitor', {
        username: user.username,
      })}
      withButton={false}
      view={'wide'}
    />
  );
};

OriginalsEmptyState.displayName = 'OriginalsEmptyState';

export default OriginalsEmptyState;
